exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".invitation[data-v-95f74776]{width:350px;max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/Invitation.vue"],"names":[],"mappings":"AACA,6BACE,YAAa,AACb,cAAgB,CACjB","file":"Invitation.vue","sourcesContent":["\n.invitation[data-v-95f74776] {\n  width: 350px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-95f74776","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Invitation.vue
// module id = 964
// module chunks = 21